import { useEffect, useMemo, useState } from 'react';
import { noop } from 'lodash';
import ShowMoreEntitiesItem from './ShowMoreEntitiesItem';

const useEntitiesList = ({
  entities,
  selectedFilters = {},
  currentMenuItem = {},
  selectedField,
  setSelectedField,
  shouldShowMoreItem,
  showMoreEntities = noop,
  keyword,
  selectedFilterType
} = {}) => {
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);

  const multiSelected = currentMenuItem?.multiSelected !== false;

  useEffect(() => {
    setSelectedCheckboxes(selectedFilters?.[currentMenuItem.id] || []);
  }, [selectedFilterType]);

  const listData = useMemo(() => {
    return entities.map(item => ({
      ...item,
      extraPayloadPicker: currentMenuItem?.extraPayloadPicker || [],
      ...(multiSelected
        ? {
            checkboxOnChange: setSelectedCheckboxes
          }
        : {
            isActive: item.id === selectedField,
            isClickToOpenNextMenu: true,
            onClick: () => setSelectedField(item.id)
          })
    }));
  }, [entities, selectedField]);

  const loadMoreItem = {
    id: 'load-more-item',
    Component: () => (
      <ShowMoreEntitiesItem
        showMore={() => showMoreEntities({ keyword })}
        isShowMore={shouldShowMoreItem && currentMenuItem?.isPaginated}
      />
    )
  };

  const listDataWithShowMore = [...listData, loadMoreItem];

  return {
    listData: listDataWithShowMore,
    selectedCheckboxes,
    setSelectedCheckboxes
  };
};

export default useEntitiesList;
